/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { Fragment } from 'react';

import { useSelector } from 'react-redux';

import { ImgStatusError, StatusStyled } from '../../../components/common/Block/Img';
import { makeSelectTranslationCommon } from '../../internationalization/intSelectors';

interface ITableNoData {
    isDataLoaded: boolean;
    isError: boolean;
}

const TableNoData = ({ isDataLoaded, isError }: ITableNoData) => {

    const { commonTable } = useSelector(makeSelectTranslationCommon());

    return (
        <Fragment>
            {
                (isError || isDataLoaded) && (
                    <StatusStyled>
                        <ImgStatusError/>
                        <div className="status__title">
                            {isError ? commonTable.error : commonTable.noData}
                        </div>
                    </StatusStyled>
                )
            }
        </Fragment>
    );
};

export default TableNoData;
